import { api } from "_shared/_stores/api";

export type PasswordChangeRequest = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

/**
 * A signed-in person replacing their own password. The API answers 204, or 400 with the field to
 * fix — `currentPassword` when the current password is wrong, `newPassword` when the rules refuse
 * the new one.
 */
export const passwordChangeApi = api.injectEndpoints({
  endpoints: (build) => ({
    changePassword: build.mutation<void, PasswordChangeRequest>({
      query: (request) => ({
        url: "users/me/password",
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const { useChangePasswordMutation } = passwordChangeApi;
